import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { BSON } from 'realm-web';
import { useRealmApp } from '../RealmApp';

const useBusiness = () => {
  const app = useRealmApp();
  const { business, loading } = useAllBusiness(app.currentUser.id);
  return {
    loading,
    business,
  };
};

function useAllBusiness(id) {
  const { data, loading, error } = useQuery(
    gql`
      query getBusiness($_id: ObjectId!) {
        business(query: { _id: $_id }) {
          _id
          address1
          address2
          city
          country
          image
          color
          language
          name
          phone
          phone2
          webPage
          zip
          currencyCode
          decimalPlaces
          idNumber
        }
      }
    `,
    { variables: { _id: new BSON.ObjectId(id) } }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const business = data?.business ?? [];
  return { business, loading };
}

export default useBusiness;
